module.exports = __webpack_public_path__ + "static/img/5.716e93f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/zh/5.png
// module id = 9r+1
// module chunks = 0